import { render } from "./ServiceTab.vue?vue&type=template&id=41079a32"
import script from "./ServiceTab.vue?vue&type=script&lang=js"
export * from "./ServiceTab.vue?vue&type=script&lang=js"
script.render = render

export default script